import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const GoliveDisplaySkeleton = () => {
  const deviceSize = useDeviceSize();
  return (
    <View>
      <Skeletons
        height={
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 200
            : 400
        }
        width={"100%"}
        style={{
          borderRadius: 10,
        }}
      />

      <Skeletons
        height={200}
        width={"100%"}
        style={{
          borderRadius: 10,
          marginTop: 10,
        }}
      />
    </View>
  );
};

export default GoliveDisplaySkeleton;
